import { Component, OnInit, Signal, input, output } from '@angular/core';
import { ButtonActionDisplayNames, ButtonActionType } from '../../../../state-management/model/enums/state.enums';
import { CommonModule } from '@angular/common';
import { MatLabel, MatOption, MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { WebsiteStateService } from '../../../../state-management/services/website-state.service';
import { ButtonAction, NavigateParams, Page, ScrollToParams } from '../../../../state-management/model/interfaces/state.model';
import { MatFormFieldModule } from '@angular/material/form-field';
import { fadeSlideInOut } from '../../../../animations';

@Component({
    selector: 'app-button-actions',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatOption,
        MatLabel,
    ],
    templateUrl: './button-actions.component.html',
    styleUrl: './button-actions.component.scss',
    animations: [ fadeSlideInOut ],
})
export class ButtonActionsComponent implements OnInit {
  readonly elemId = input.required<string>();
  readonly closePanel = output<void>();
  
  public ButtonActionType = ButtonActionType;
  public actionTypes = Object.values(ButtonActionType);
  public displayNames = ButtonActionDisplayNames; // Mapping der Display-Namen
  public allPages$: Signal<Page[]> = this.stateService.allPages;
  public allCurrentComponents$: Signal<string[]> = this.stateService.sortedActiveComponentIds
  
  public config: ButtonAction = { type: ButtonActionType.ScrollTo, params: { target: '' } };

  constructor(private stateService: WebsiteStateService) { }

  ngOnInit(): void {
    const currentElement = this.stateService.getCurrentElement(this.elemId())();
    if (currentElement.success === false) return;
    this.config = currentElement.payload.buttonConfig || { type: ButtonActionType.ScrollTo, params: { target: '' } };
  }

  public onTypeChange(): void {
    switch (this.config.type) {
      case ButtonActionType.ScrollTo:
        this.config.params = { target: '' };
        break;
      case ButtonActionType.Navigate:
        this.config.params = { url: '' };
        break;
    }
    this.validateAndSave();
  } 

  public validateAndSave(): void {
    if (this.#isValidConfig()) {
      this.#updateConfig();
    }
  }

  public close() {
    this.closePanel.emit();
  }

  public isScrollToParams(params: any): params is ScrollToParams {
    return params && typeof params.target === 'string';
  }

  public isNavigateParams(params: any): params is NavigateParams {
    return params && typeof params.url === 'string';
  }


  // ### Private methods ####
  #isValidConfig(): boolean {
    if (!this.config) return false;

    switch (this.config.type) {
      case ButtonActionType.ScrollTo:
        return !!this.config.params?.target; // Ziel muss definiert sein
      case ButtonActionType.Navigate:
        return !!this.config.params?.url; // URL muss definiert sein
      default:
        return false;
    }
  }

  #updateConfig(): void {
    if (!this.#isValidConfig()) {
      console.warn('Ungültige Konfiguration. Änderungen werden nicht gespeichert.');
      return;
    }

    const elemId = this.elemId();
    if (elemId) {
      this.stateService.updateElement(elemId, { buttonConfig: { ...this.config } });
    }
  }
}
